import { Link } from "react-router-dom";
import { type PostSummary } from "@/lib/site";
import { CardImage } from "@/components/site/CardImage";
import { SectionLabel } from "@/components/site/HomeBlocks";

export function PostCard({ post, index = 0 }: { post: PostSummary; index?: number }) {
  return (
    <Link to={`/${post.slug}`} className="calm-card group block overflow-hidden fade-up"
      style={{ animationDelay: `${Math.min(index, 8) * 50}ms` }} data-testid={`post-card-${post.slug}`}>
      <div className="aspect-[4/3] overflow-hidden border-b border-[#F5F5F4] bg-[#F5F5F4]">
        <CardImage post={post} />
      </div>
      <div className="flex flex-col gap-2 p-5">
        <div className="flex flex-wrap gap-2">
          <SectionLabel slug={post.section} />
          {post.refreshed && <span className="pill">Step-by-step</span>}
        </div>
        <h3 className="shop-h2 text-lg leading-snug">{post.title}</h3>
        <p className="line-clamp-2 text-sm text-[#78716C]">{post.description}</p>
      </div>
    </Link>
  );
}
